import PortalNav from "../components/PortalNav";
import { useAuth } from "../context/AuthContext";

const HERBAL = [
  { time: "Morning", item: "Adaptogen tonic — ashwagandha + reishi" },
  { time: "Midday", item: "Nervine tea — passionflower + lemon balm" },
  { time: "Evening", item: "Magnesium glycinate + skullcap tincture" },
];

const MILESTONES = [
  { day: "Day 07", label: "Deep Reset begins", state: "current" },
  { day: "Day 14", label: "Mid-residency check-in", state: "upcoming" },
  { day: "Day 21", label: "Closing wine celebration", state: "upcoming" },
  { day: "Day 22+", label: "Alumni orientation", state: "locked" },
];

export default function MyProgram() {
  const { user } = useAuth();
  return (
    <div className="portal-body" data-testid="my-program-page">
      <header style={{ background: "var(--charcoal)", color: "var(--ivory)", padding: "28px 24px 32px" }}>
        <div className="container-x">
          <p className="eyebrow eyebrow-light">Your Program</p>
          <h1 style={{ fontFamily: "var(--serif)", fontWeight: 300, fontSize: "clamp(1.8rem, 4vw, 2.4rem)", margin: "10px 0" }}>The residency, curated for you.</h1>
        </div>
      </header>

      <main className="container-x" style={{ padding: "32px 24px", display: "grid", gap: 24 }}>
        {/* Intake summary */}
        <div className="portal-card" data-testid="intake-summary">
          <p className="eyebrow" style={{ marginBottom: 12 }}>Intake Summary</p>
          <h3>{user?.name || "Guest"} — Soft Life Reset</h3>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 16, marginTop: 20 }}>
            {[
              ["Program", "21-Day Residency"],
              ["Start", user?.start_date || "This week"],
              ["Guide", "Amara J."],
              ["Suite", "The Camellia"],
            ].map(([k, v]) => (
              <div key={k}>
                <p style={{ fontSize: ".68rem", letterSpacing: ".2em", textTransform: "uppercase", color: "var(--warm-gray)", margin: "0 0 6px" }}>{k}</p>
                <p style={{ fontFamily: "var(--serif)", fontSize: "1.1rem", margin: 0 }}>{v}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Herbal regimen */}
        <div className="portal-card" data-testid="herbal-regimen">
          <p className="eyebrow" style={{ marginBottom: 12 }}>Herbal Regimen</p>
          <h3>Your daily botanical schedule</h3>
          <div style={{ marginTop: 20 }}>
            {HERBAL.map((h) => (
              <div key={h.time} style={{ display: "grid", gridTemplateColumns: "120px 1fr", gap: 16, padding: "14px 0", borderBottom: "1px solid rgba(184,150,90,.15)" }}>
                <span style={{ fontSize: ".72rem", letterSpacing: ".2em", textTransform: "uppercase", color: "var(--gold)" }}>{h.time}</span>
                <span style={{ fontFamily: "var(--serif)", fontSize: "1.05rem" }}>{h.item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Nutrition */}
        <div className="portal-card" data-testid="nutrition-framework">
          <p className="eyebrow" style={{ marginBottom: 12 }}>Nutrition Framework</p>
          <h3>Hormone-forward, softly structured</h3>
          <p className="body-sm" style={{ marginTop: 12 }}>
            Three chef-crafted meals daily, aligned with your intake profile. Warm, cooked, grounding. No calorie tracking — only nourishment, ritual, and rhythm.
          </p>
        </div>

        {/* Milestones */}
        <div className="portal-card" data-testid="milestones">
          <p className="eyebrow" style={{ marginBottom: 12 }}>Upcoming Milestones</p>
          <div style={{ marginTop: 16 }}>
            {MILESTONES.map((m) => (
              <div key={m.day} style={{ display: "grid", gridTemplateColumns: "100px 1fr auto", gap: 16, padding: "14px 0", borderBottom: "1px solid rgba(184,150,90,.15)", alignItems: "center" }}>
                <span style={{ fontFamily: "var(--serif)", fontSize: "1.05rem", color: m.state === "current" ? "var(--gold)" : "var(--charcoal)" }}>{m.day}</span>
                <span style={{ fontSize: ".95rem", color: m.state === "locked" ? "var(--warm-gray)" : "var(--charcoal)" }}>{m.label}</span>
                <span style={{ fontSize: ".64rem", letterSpacing: ".2em", textTransform: "uppercase", color: m.state === "current" ? "var(--gold)" : "var(--warm-gray)" }}>
                  {m.state === "current" ? "You are here" : m.state === "locked" ? "Locked" : "Upcoming"}
                </span>
              </div>
            ))}
          </div>
        </div>
      </main>
      <PortalNav />
    </div>
  );
}
